import { useEffect, useMemo, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { customStyles, mapToOptions } from "../utils/utils";
import Select from "../../../components/AppSelect";
import { connect } from "react-redux";
import { buttonIcon, buttonTypes } from "../../../utils/buttonsUtil";

const FilterBarProductsComponent = ({
  search = "",
  offset = 10,
  shippers = [],
  categories = [],
  subCategories = [],
  reduxGetShippers = () => { },
  reduxGetCategories = () => { },
  reduxGetSubCategories = () => { },
  reduxGetProducts = () => { },
  reduxDownloadProducts = () => { },
}) => {
  const [shippersSelected, setShippersSelected] = useState([]);
  const [categoriesSelected, setCategoriesSelected] = useState([]);
  const [subCategoriesSelected, setSubCategoriesSelected] = useState([]);

  const shippersOptions = useMemo(() => {
    return mapToOptions(shippers?.items ?? [], "idCompany", "description");
  }, [shippers]);

  const categoriesOptions = useMemo(() => {
    return mapToOptions(categories?.items ?? [], "idCategory", "name");
  }, [categories]);

  const subCategoriesOptions = useMemo(() => {
    return mapToOptions(subCategories ?? [], "id", "subCategoryName");
  }, [subCategories]);

  useEffect(() => {
    if (!shippers?.items?.length) {
      reduxGetShippers({
        page: 1,
        offset: offset,
        search: "",
      });
    }

    if (!categories?.items?.length) {
      reduxGetCategories({
        page: 1,
        offset: "",
        search: "",
        isActive: true,
      });
    }

    if (!subCategories?.length) {
      reduxGetSubCategories();
    }
  }, []);

  const handleClickDownloadFile = () => {
    let filters = {
      search: search,
      shipperIds: shippersSelected,
      categoryIds: categoriesSelected,
      subCategoryIds: subCategoriesSelected,
    };

    reduxDownloadProducts(filters);
  };

  useEffect(() => {
    let filters = {
      page: 1,
      offset: offset,
      search: search,
    };
    if (
      shippersSelected.length ||
      categoriesSelected.length ||
      subCategoriesSelected.length
    ) {
      filters = {
        ...filters,
        shippersSelected,
        categoriesSelected,
        subCategoriesSelected
      };
    }
    reduxGetProducts(filters);
  }, [
    search,
    offset,
    shippersSelected,
    categoriesSelected,
    subCategoriesSelected
  ]);

  return (
    <div className="mb-4">
      <Row className="gy-4">
        <Col className="px-3 pb-2">
          <label htmlFor="countryId" className="form-label">
            Remitente
          </label>
          <Select
            isMulti
            placeholder="Seleccionar"
            styles={customStyles}
            options={shippersOptions}
            onChange={(selectedOptions) => {
              const ids = selectedOptions.map((element) => element.value);
              setShippersSelected(ids);
            }}
          />
        </Col>
        <Col className="px-3 pb-2">
          <label htmlFor="countryId" className="form-label">
            Categoría
          </label>
          <Select
            isMulti
            placeholder="Seleccionar"
            styles={customStyles}
            options={categoriesOptions}
            onChange={(selectedOptions) => {
              const ids = selectedOptions.map((element) => element.value);
              setCategoriesSelected(ids);
            }}
          />
        </Col>
        <Col className="px-3 pb-2">
          <label htmlFor="countryId" className="form-label">
            Subcategoría
          </label>
          <Select
            isMulti
            placeholder="Seleccionar"
            styles={customStyles}
            options={subCategoriesOptions}
            onChange={(selectedOptions) => {
              const ids = selectedOptions.map((element) => element.value);
              setSubCategoriesSelected(ids);
            }}
          />
        </Col>
        <Col className="pb-2 d-flex align-items-end">
          <button
            title={"Descargar productos"}
            className={`btn ${buttonTypes.Success} btn-circle`}
            type="button"
            onClick={() => handleClickDownloadFile()}
          >
            <i className={`fas ${buttonIcon.DownloadFile}`}></i>
          </button>
        </Col>
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetShippers: (payload) =>
      dispatch({
        type: "FETCH_COMPANIESBYSHIPPER_REQUEST",
        value: payload,
      }),
    reduxGetCategories: (payload) =>
      dispatch({
        type: "FETCH_CATEGORIES_REQUEST",
        value: payload,
      }),
    reduxGetSubCategories: (payload) =>
      dispatch({
        type: "GET_ALL_ACTIVE_SUB_CATEGORIES_REQUEST",
        value: payload,
      }),
    reduxGetProducts: (payload) =>
      dispatch({
        type: "FETCH_PRODUCTS_REQUEST",
        value: payload,
      }),
    reduxDownloadProducts: (payload) =>
      dispatch({
        type: "DOWNLOAD_PRODUCTS_REQUEST",
        value: payload,
      }),
  };
};

const mapStateToProps = (state) => {
  return {
    shippers: state.companyState.clients,
    categories: state.categoryState.categories,
    subCategories: state.subCategoriesState.subCategoriesActive,
  };
};

export const FilterBarProducts = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterBarProductsComponent);
